import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

// Create the Sanity client
export const client = createClient({
  projectId: '4isryep1', // Your Sanity project ID
  dataset: 'production', // Your dataset name
  useCdn: true, // Use CDN for faster, cached responses
  apiVersion: '2024-01-01', // Use current API version
})

// Helper function to generate image URLs
const builder = imageUrlBuilder(client)

export const urlFor = (source) => {
  return builder.image(source)
}

// GROQ queries for fetching blog posts
export const blogQueries = {
  // Get all published blog posts
  getAllPosts: `*[_type == "blog" && defined(slug.current)] | order(publishedAt desc) {
    _id,
    title,
    slug,
    publishedAt,
    mainImage,
    excerpt,
    metaTitle,
    metaDescription,
    "estimatedReadingTime": round(length(pt::text(body)) / 5 / 180 )
  }`,
  
  // Get a single blog post by slug
  getPostBySlug: `*[_type == "blog" && slug.current == $slug][0] {
    _id,
    title,
    slug,
    publishedAt,
    mainImage,
    body,
    excerpt,
    metaTitle,
    metaDescription,
    "estimatedReadingTime": round(length(pt::text(body)) / 5 / 180 )
  }`,
  
  // Get recent blog posts (for homepage/sidebar)
  getRecentPosts: `*[_type == "blog" && defined(slug.current)] | order(publishedAt desc)[0...3] {
    _id,
    title,
    slug,
    publishedAt,
    mainImage,
    excerpt,
    metaTitle,
    metaDescription
  }`
} 